<template>
  <div v-if="ready">
    <b-spinner v-if="loading" />
    <scrollable-table :items="groupedItems" v-if="!loading" />
  </div>
</template>

<script>
import ScrollableTable from "../../../components/ScrollableTable.vue";
import _ from "lodash";

export default {
  components: { ScrollableTable },
  props: ["client_customer", "from_date", "to_date", "product", "process_type"],
  data() {
    return {
      loading: true,
      ready: false,
      items: []
    };
  },
  computed: {
    groupedItems() {
      const descarte = _.filter(this.items, (i) => i.exportable === false);
      const exportacion = _.filter(this.items, (i) => i.exportable === true);

      const SEPERATOR = "--";
      const d = {};

      const a = _.chain(descarte)
        .groupBy((item) => `${item.numero}${SEPERATOR}${item.tipo_producto}`)
        .map((objs, id) => {
          if (!d[id.split(SEPERATOR)[0]]) {
            d[id.split(SEPERATOR)[0]] = {};
          }
          d[id.split(SEPERATOR)[0]][id.split(SEPERATOR)[1]] = _.sumBy(objs, (o) => o.kilos_volteados);
        })
        .value();

      const groupedItems = _.chain(exportacion)
        .groupBy((item) => `${item.numero}${SEPERATOR}${item.tipo_producto}${SEPERATOR}${item.fecha}`)
        .map((objs, id) => ({
          numero: id.split(SEPERATOR)[0],
          fecha: id.split(SEPERATOR)[2],
          cajas: _.sumBy(objs, (o) => o.cajas),
          kilos_embalados: _.sumBy(objs, (o) => o.kilos_volteados),
          kilos_exportacion: _.sumBy(objs, (o) => parseFloat(o.kilos_exportacion)),
          kilos_dh: _.sumBy(objs, (o) => parseFloat(o.kilos_dh)),
          ...d[id.split(SEPERATOR)[0]]
        }))
        .value();
      const toSum = ["kilos_embalados", ...Object.keys(_(descarte).groupBy("tipo_producto").value())];
      for (let item of groupedItems) {
        let sum = 0;
        for (let sumKey of toSum) {
          sum += item[sumKey] ? parseFloat(item[sumKey]) : 0;
        }
        item["kilos_volteados"] = sum.toFixed(2);
        item["%_embalaje"] = ((parseFloat(item["kilos_embalados"]) / sum) * 100).toFixed(2);
      }
      return groupedItems;
    }
  },
  async mounted() {
    this.loading = true;
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/process/all_processes?client_customer=${this.client_customer}&product=${this.product}&process_type=${this.process_type}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.items = response.data;
      this.ready = true;
      this.loading = false;
      this.$emit("chart-ready");
    } catch (e) {
      this.loading = false;
      console.log(e.message);
    }
  }
};
</script>

<style></style>
